<template>
  <b-row>
    <b-col cols="12">
      <div v-if="type === 'TAMANO'">
        <b-form-row>
          <b-form-group
            id="input-parent"
            class="col-12"
            :label="label"
            label-for="parent"
          >
            <b-form-select
              :disabled="disabled"
              @change="TAMANOfixedSizeSelected"
              v-model="$v.form.fixed_size.$model"
              :options="selector_options"
              id="parent"
            ></b-form-select>
          </b-form-group>
          <b-form-group
            id="input-base_width"
            class="col-12"
            label-for="base_width"
          >
            <b-form-row>
              <b-col :cols="6">
                <b-input-group>
                  <b-form-input
                    :disabled="disabled"
                    placeholder="Ancho"
                    id="extra_width"
                    :value="$v.form.extra_width.$model.replace('.', ',')"
                    @change="
                      setDecimal('extra_width', $event);
                      TAMANOOptionSelected();
                    "
                    :state="validateState('extra_width')"
                  ></b-form-input>
                  <template #append>
                    <b-input-group-text>cm</b-input-group-text>
                  </template>
                </b-input-group>
              </b-col>
              <b-col :cols="6">
                <b-input-group>
                  <b-form-input
                    :disabled="disabled"
                    placeholder="Largo"
                    id="extra_length"
                    :value="$v.form.extra_length.$model.replace('.', ',')"
                    @change="
                      setDecimal('extra_length', $event);
                      TAMANOOptionSelected();
                    "
                    :state="validateState('extra_length')"
                  ></b-form-input>
                  <template #append>
                    <b-input-group-text>cm</b-input-group-text>
                  </template>
                </b-input-group>
              </b-col>
            </b-form-row>
          </b-form-group>
        </b-form-row>
      </div>
      <div v-if="type === 'CAIDA'">
        <b-form-row>
          <b-form-group
            id="input-parent"
            class="col-12"
            :label="label"
            label-for="parent"
          >
            <b-form-select
              :disabled="disabled"
              @change="CAIDAfixedSizeSelected"
              v-model="$v.form.fixed_size.$model"
              :options="selector_options"
              id="parent"
            ></b-form-select>
          </b-form-group>
          <b-form-group
            id="input-base_width"
            class="col-12"
            label-for="base_width"
          >
            <b-form-row>
              <b-col :cols="6">
                <b-input-group>
                  <b-form-input
                    :disabled="disabled"
                    placeholder="Ancho"
                    id="extra_fall"
                    :value="$v.form.extra_fall.$model.replace('.', ',')"
                    @change="
                      setDecimal('extra_fall', $event);
                      CAIDAOptionSelected();
                    "
                    :state="validateState('extra_fall')"
                  ></b-form-input>
                  <template #append>
                    <b-input-group-text>cm</b-input-group-text>
                  </template>
                </b-input-group>
              </b-col>
            </b-form-row>
          </b-form-group>
        </b-form-row>
      </div>
      <div v-if="type === 'TAMANO_LIBRE'">
        <b-form-row>
          <b-form-group
            id="input-base_width"
            class="col-12"
            :label="label"
            label-for="base_width"
          >
            <b-form-row>
              <b-col :cols="6">
                <b-input-group>
                  <b-form-input
                    :disabled="disabled"
                    placeholder="Ancho"
                    id="extra_width"
                    :value="$v.form.extra_width.$model.replace('.', ',')"
                    @change="
                      setDecimal('extra_width', $event);
                      TAMANO_LIBREOptionSelected();
                    "
                    :state="validateState('extra_width')"
                  ></b-form-input>
                  <template #append>
                    <b-input-group-text>cm</b-input-group-text>
                  </template>
                </b-input-group>
              </b-col>
              <b-col :cols="6">
                <b-input-group>
                  <b-form-input
                    :disabled="disabled"
                    placeholder="Largo"
                    id="extra_length"
                    :value="$v.form.extra_length.$model.replace('.', ',')"
                    @change="
                      setDecimal('extra_length', $event);
                      TAMANO_LIBREOptionSelected();
                    "
                    :state="validateState('extra_length')"
                  ></b-form-input>
                  <template #append>
                    <b-input-group-text>cm</b-input-group-text>
                  </template>
                </b-input-group>
              </b-col>
            </b-form-row>
          </b-form-group>
        </b-form-row>
      </div>
      <div v-if="type === 'TAMANO_LIBRE_CAMA'">
        <b-form-row>
          <b-form-group
            id="input-base_width"
            class="col-12"
            :label="label"
            label-for="base_width"
          >
            <b-form-row>
              <b-col :cols="12">
                <b-input-group>
                  <template #prepend>
                    <b-input-group-text>Ancho</b-input-group-text>
                  </template>
                  <b-form-input
                    :disabled="disabled"
                    id="extra_width"
                    :value="$v.form.extra_width.$model.replace('.', ',')"
                    @change="
                      setDecimal('extra_width', $event);
                      TAMANO_LIBRE_CAMAOptionSelected();
                    "
                    :state="validateState('extra_width')"
                  ></b-form-input>
                  <template #append>
                    <b-input-group-text>cm</b-input-group-text>
                  </template>
                </b-input-group>
              </b-col>
              <b-col :cols="12" class="mt-3">
                <b-input-group>
                  <template #prepend>
                    <b-input-group-text>Largo</b-input-group-text>
                  </template>
                  <b-form-input
                    :disabled="disabled"
                    id="extra_length"
                    :value="$v.form.extra_length.$model.replace('.', ',')"
                    @change="
                      setDecimal('extra_length', $event);
                      TAMANO_LIBRE_CAMAOptionSelected();
                    "
                    :state="validateState('extra_length')"
                  ></b-form-input>
                  <template #append>
                    <b-input-group-text>cm</b-input-group-text>
                  </template>
                </b-input-group>
              </b-col>
              <b-col :cols="12" class="mt-3">
                <b-input-group>
                  <template #prepend>
                    <b-input-group-text>Alto</b-input-group-text>
                  </template>
                  <b-form-input
                    :disabled="disabled"
                    id="extra_height"
                    :value="$v.form.extra_height.$model.replace('.', ',')"
                    @change="
                      setDecimal('extra_height', $event);
                      TAMANO_LIBRE_CAMAOptionSelected();
                    "
                    :state="validateState('extra_height')"
                  ></b-form-input>
                  <template #append>
                    <b-input-group-text>cm</b-input-group-text>
                  </template>
                </b-input-group>
              </b-col>
            </b-form-row>
          </b-form-group>
        </b-form-row>
      </div>
      <div v-if="type === 'TAMANO_DIAM'">
        <b-form-row>
          <b-form-group
            id="input-parent"
            class="col-12"
            :label="label"
            label-for="parent"
          >
            <b-form-select
              :disabled="disabled"
              @change="TAMANO_DIAMfixedSizeSelected"
              v-model="$v.form.fixed_size.$model"
              :options="selector_options"
              id="parent"
            ></b-form-select>
          </b-form-group>
          <b-form-group
            id="input-base_width"
            class="col-12"
            label-for="base_width"
          >
            <b-form-row>
              <b-col :cols="12">
                <b-input-group>
                  <b-form-input
                    :disabled="disabled"
                    placeholder="Diámetro"
                    id="extra_diameter"
                    :value="$v.form.extra_diameter.$model.replace('.', ',')"
                    @change="
                      setDecimal('extra_diameter', $event);
                      TAMANO_DIAMOptionSelected();
                    "
                    :state="validateState('extra_diameter')"
                  ></b-form-input>
                  <template #append>
                    <b-input-group-text>cm</b-input-group-text>
                  </template>
                </b-input-group>
              </b-col>
            </b-form-row>
          </b-form-group>
        </b-form-row>
      </div>
      <div v-else-if="type === 'TELA'">
        <b-form-row>
          <b-form-group
            id="input-parent"
            class="col-12"
            :label="label"
            label-for="parent"
          >
            <b-form-select
              :disabled="disabled"
              @change="genericOptionSelected"
              :options="selector_options"
              id="parent"
              v-model="$v.form.value.$model"
            ></b-form-select>
            <div v-if="form.barcadaInfo">
              <small>
                Barcada {{ form.barcadaInfo['barcada'] }} ({{
                  form.barcadaInfo['remaining_meters']
                }}
                m. restantes)
              </small>
            </div>
          </b-form-group>
        </b-form-row>
      </div>
      <div v-else-if="type === 'TIRA_BORDADA'">
        <b-form-row>
          <b-form-group
            id="input-parent"
            class="col-12"
            :label="label"
            label-for="parent"
          >
            <b-form-select
              :disabled="disabled"
              @change="genericOptionSelected"
              :options="selector_options"
              id="parent"
              v-model="$v.form.value.$model"
            ></b-form-select>
          </b-form-group>
        </b-form-row>
      </div>
      <div v-else-if="type === 'TIRA_BORDADA_CON_ENTREDOS'">
        <b-form-row>
          <b-form-group
            id="input-parent"
            class="col-12"
            :label="label"
            label-for="parent"
          >
            <b-form-select
              :disabled="disabled"
              @change="genericOptionSelected"
              :options="selector_options"
              id="parent"
              v-model="$v.form.value.$model"
            ></b-form-select>
          </b-form-group>
        </b-form-row>
      </div>
      <div v-else-if="type === 'HILO'">
        <b-form-row>
          <b-form-group
            id="input-parent"
            class="col-12"
            :label="label"
            label-for="parent"
          >
            <b-form-select
              :disabled="disabled"
              @change="genericOptionSelected"
              :options="selector_options"
              id="parent"
              v-model="$v.form.value.$model"
            ></b-form-select>
          </b-form-group>
        </b-form-row>
      </div>
      <div v-else-if="type === 'PUNTADA'">
        <b-form-row>
          <b-form-group
            id="input-parent"
            class="col-12"
            :label="label"
            label-for="parent"
          >
            <b-form-select
              :disabled="disabled"
              @change="genericOptionSelected"
              :options="selector_options"
              id="parent"
              v-model="$v.form.value.$model"
            ></b-form-select>
          </b-form-group>
        </b-form-row>
      </div>
      <!-- <div v-else-if="type === 'HILO_PUNTADA'">
        <b-form-row>
          <b-form-group
            id="input-parent"
            class="col-12"
            :label="label"
            label-for="parent"
          >
            <b-form-select
              @change="genericOptionSelected"
              :options="selector_options"
              id="parent"
              v-model="$v.form.value.$model"
              
            ></b-form-select>
            
          </b-form-group>
        </b-form-row>
      </div> -->
      <div v-else-if="type === 'BORDADO'">
        <label>{{ label }}</label>
        <b-form-row>
          <b-form-group id="input-enabled" class="col-6" label-for="enabled">
            <b-form-checkbox
              :disabled="disabled"
              switch
              v-model="$v.form.enabled.$model"
              @change="BORDADOChanged()"
              name="input-enabled"
              >{{
                $v.form.enabled.$model ? 'Incluir' : 'No incluir'
              }}</b-form-checkbox
            >
          </b-form-group>

          <b-col cols="12" v-if="$v.form.enabled.$model">
            <b-form-row>
              <b-form-group
                id="input-is_standard"
                class="col-6"
                label-for="is_standard"
              >
                <b-form-checkbox
                  :disabled="disabled"
                  switch
                  @change="
                    BORDADOTypeChanged();
                    BORDADOChanged();
                  "
                  v-model="$v.form.is_standard.$model"
                  name="input-is_standard"
                  >{{
                    $v.form.is_standard.$model ? 'Estándar' : 'Personalizado'
                  }}</b-form-checkbox
                >
              </b-form-group>

              <b-form-group
                id="input-size"
                class="col-12"
                label="Tamaño"
                label-for="size"
              >
                <b-form-select
                  :disabled="disabled"
                  :options="extra.embroiderySizes"
                  :state="validateState('size')"
                  id="size"
                  @change="
                    BORDADOStandardSizeChanged();
                    BORDADOChanged();
                  "
                  v-model="$v.form.size.$model"
                ></b-form-select>
              </b-form-group>

              <b-form-group
                v-if="!$v.form.is_standard.$model"
                id="input-size"
                class="col-12"
                label="Imagen"
                label-for="size"
              >
                <b-form-file
                  :disabled="disabled"
                  accept="image/*"
                  id="imageRaw"
                  :state="validateState('image')"
                  @input="BORDADOImageChanged"
                  drop-placeholder="Arrastra un archivo aquí..."
                ></b-form-file>

                <div class="mt-2" v-if="$v.form.image.$model">
                  <img style="max-width: 100%" :src="$v.form.image.$model" />
                </div>
              </b-form-group>

              <b-form-group
                v-if="$v.form.is_standard.$model"
                id="input-category"
                class="col-12"
                label="Categoría"
                label-for="category"
              >
                <b-form-select
                  :disabled="disabled || !$v.form.size.$model"
                  :options="extra.standardEmbroideryCategories"
                  :state="validateState('category')"
                  @change="BORDADOStandardCategoryChanged()"
                  id="category"
                  v-model="$v.form.category.$model"
                ></b-form-select>
              </b-form-group>
              <b-form-group
                v-if="$v.form.is_standard.$model"
                id="input-embroidery"
                class="col-12"
                label="Bordado"
                label-for="embroidery"
              >
                <b-form-select
                  @change="
                    BORDADOStandardEmbroideryChanged();
                    BORDADOChanged();
                  "
                  :disabled="
                    disabled || !$v.form.size.$model || !$v.form.category.$model
                  "
                  :options="extra.standardEmbroideriesFiltered"
                  :state="validateState('embroidery')"
                  id="embroidery"
                  v-model="$v.form.embroidery.$model"
                ></b-form-select>
              </b-form-group>

              <b-form-group
                v-if="
                  ($v.form.is_standard.$model && $v.form.embroidery.$model) ||
                  !$v.form.is_standard.$model
                "
                id="input-is_monocolor"
                class="col-12"
                label-for="is_monocolor"
              >
                <b-form-checkbox
                  switch
                  @change="BORDADOSColorSwitchChanged"
                  :disabled="disabled || disableIsMonocolor()"
                  v-model="$v.form.is_monocolor.$model"
                  name="input-is_monocolor"
                  >{{ formatIsMonocolorStr() }}</b-form-checkbox
                >
              </b-form-group>

              <b-form-group
                v-if="
                  ($v.form.is_standard.$model && $v.form.embroidery.$model) ||
                  !$v.form.is_standard.$model
                "
                id="input-group-colors"
                label="Hilos"
                class="col-12"
                label-for="input-colors"
              >
                <b-input-group>
                  <multiselect
                    :disabled="disabled"
                    @input="BORDADOColorsChanged"
                    :close-on-select="false"
                    :clear-on-select="true"
                    placeholder=""
                    :state="validateState('colors')"
                    :max="
                      $v.form.is_monocolor.$model
                        ? 1
                        : extra.standardEmbroideryNumColors
                    "
                    track-by="value"
                    :class="$v.form.colors.$error ? 'is-invalid' : ''"
                    :multiple="true"
                    label="text"
                    v-model="$v.form.colors.$model"
                    :options="extra_info.color_options"
                  >
                    <!-- !$v.form.is_monocolor.$model !-->
                  </multiselect>
                </b-input-group>
              </b-form-group>
            </b-form-row>
          </b-col>
        </b-form-row>
      </div>
      <div v-else-if="type === 'INICIALES'">
        <label>{{ label }}</label>
        <b-form-row>
          <b-form-group id="input-enabled" class="col-6" label-for="enabled">
            <b-form-checkbox
              :disabled="disabled"
              switch
              @change="INICIALESChanged()"
              v-model="$v.form.enabled.$model"
              name="input-enabled"
              >{{
                $v.form.enabled.$model ? 'Incluir' : 'No incluir'
              }}</b-form-checkbox
            >
          </b-form-group>

          <b-col cols="12" v-if="$v.form.enabled.$model">
            <b-form-row>
              <b-form-group id="input-text" class="col-6" label-for="text">
                <b-form-input
                  :disabled="disabled"
                  placeholder="Texto"
                  id="text"
                  @change="INICIALESChanged()"
                  v-model="$v.form.text.$model"
                  :state="validateState('text')"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                id="input-size"
                class="col-12"
                label="Tamaño"
                label-for="size"
              >
                <b-form-select
                  :disabled="disabled"
                  :options="extra.initialSizes"
                  id="size"
                  @change="
                    INICIALESSizeChanged();
                    INICIALESChanged();
                  "
                  :state="validateState('size')"
                  v-model="$v.form.size.$model"
                ></b-form-select>
              </b-form-group>

              <b-form-group
                id="input-typography"
                class="col-12"
                label="Tipografía"
                label-for="typography"
              >
                <b-form-select
                  :disabled="disabled || !$v.form.size.$model"
                  :options="extra.initialFilteredTypographies"
                  id="typography"
                  :state="validateState('typography')"
                  @change="INICIALESChanged()"
                  v-model="$v.form.typography.$model"
                ></b-form-select>
              </b-form-group>

              <b-form-group
                id="input-color"
                class="col-12"
                label="Color del hilo"
                label-for="color"
              >
                <b-form-select
                  :disabled="disabled"
                  @change="INICIALESChanged()"
                  :options="extra_info.color_options"
                  id="color"
                  v-model="$v.form.color.$model"
                  :state="validateState('color')"
                ></b-form-select>
              </b-form-group>
            </b-form-row>
          </b-col>
        </b-form-row>
      </div>
      <div v-else-if="type === 'INPUT'">
        <b-form-row>
          <b-form-group
            id="input-parent"
            class="col-12"
            :label="label"
            label-for="parent"
          >
            <b-form-input
              :disabled="disabled"
              :state="validateState('value')"
              :value="$v.form.value.$model.replace('.', ',')"
              @change="
                setDecimal('value', $event);
                INPUTChanged();
              "
            ></b-form-input>
          </b-form-group>
        </b-form-row>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { uris, actions } from '@/admin/api.js';
import {
  required,
  minLength,
  decimal,
  numeric,
  requiredIf,
  minValue,
} from 'vuelidate/lib/validators';
import { fabric } from 'fabric';

import store from '@/admin/store.js';
import { validationMixin } from 'vuelidate';
import Multiselect from 'vue-multiselect';

import { helpers } from 'vuelidate/lib/validators';

const isValidImage = (image) =>
  !helpers.req(image) || ['image/jpeg', 'image/png'].includes(image['type']);

export default {
  name: 'CustomizerAttributeSelector',
  props: {
    type: String,
    label: String,
    selector_options: Array,
    extra_info: Object,
    initialValue: Object,
    disabled: Boolean,
  },
  components: { Multiselect },
  mixins: [validationMixin],
  validations() {
    let rules = {
      TAMANO: {
        extra_width: { required, decimal },
        extra_length: { required, decimal },
        fixed_size: {},
      },
      TAMANO_DIAM: {
        extra_diameter: { required, decimal },
        fixed_size: {},
      },
      TAMANO_LIBRE: {
        extra_width: { required, decimal },
        extra_length: { required, decimal },
      },
      TAMANO_LIBRE_CAMA: {
        extra_width: { required, decimal },
        extra_length: { required, decimal },
        extra_height: { required, decimal },
      },
      CAIDA: {
        extra_fall: { required, decimal },
        fixed_size: {},
      },
      TELA: {
        value: { required },
      },
      TIRA_BORDADA: {
        value: { required },
      },
      TIRA_BORDADA_CON_ENTREDOS: {
        value: { required },
      },
      HILO: {
        value: { required },
      },
      PUNTADA: {
        value: { required },
      },
      // HILO_PUNTADA: {
      //   value: { required },
      // },
      BORDADO: {
        enabled: { required },
        is_standard: {
          required: requiredIf(function (form) {
            return form.enabled;
          }),
        },
        size: {
          required: requiredIf(function (form) {
            return form.enabled;
          }),
        },
        category: {
          required: requiredIf(function (form) {
            return form.enabled && form.is_standard;
          }),
        },
        embroidery: {
          required: requiredIf(function (form) {
            return form.enabled && form.is_standard;
          }),
        },
        image: {
          required: requiredIf(function (form) {
            return form.enabled && !form.is_standard;
          }),
        },
        is_monocolor: {
          required: requiredIf(function (form) {
            return (
              form.enabled &&
              ((form.is_standard && form.embroidery) || !form.is_standard)
            );
          }),
        },
        colors: {
          minLength: minLength(1),
          $each: {
            text: { required },
            value: { required },
          },
          required: requiredIf(function (form) {
            return (
              form.enabled &&
              ((form.is_standard && form.embroidery) || !form.is_standard)
            );
          }),
        },
      },
      INICIALES: {
        enabled: { required },
        text: {
          required: requiredIf(function (form) {
            return form.enabled;
          }),
        },
        size: {
          required: requiredIf(function (form) {
            return form.enabled;
          }),
        },
        typography: {
          required: requiredIf(function (form) {
            return form.enabled;
          }),
        },
        color: {
          required: requiredIf(function (form) {
            return form.enabled;
          }),
        },
      },
      INPUT: {
        value: { required },
      },
    };

    return { form: rules[this.type] };
  },
  data() {
    let form = {
      TAMANO: {
        extra_width: '0.0',
        extra_length: '0.0',
        fixed_size: null,
      },
      TAMANO_LIBRE: {
        extra_width: '100.0',
        extra_length: '150.0',
      },
      TAMANO_LIBRE_CAMA: {
        extra_width: '100.0',
        extra_length: '150.0',
        extra_height: '50.0',
      },
      TAMANO_DIAM: {
        extra_diameter: '0.0',
        fixed_size: null,
      },
      CAIDA: {
        extra_fall: '0.0',
        fixed_size: null,
      },
      INPUT: {
        value: '',
      },
      TELA: {
        value: null,
        barcadaInfo: null,
      },
      TIRA_BORDADA: {
        value: null,
      },
      TIRA_BORDADA_CON_ENTREDOS: {
        value: null,
      },
      HILO: {
        value: null,
      },
      PUNTADA: {
        value: null,
      },
      // HILO_PUNTADA: {
      //   value: null,
      // },
      BORDADO: {
        enabled: false,
        is_standard: true,
        size: null,
        category: null,
        embroidery: null,
        image: null,
        is_monocolor: false,
        colors: [],
      },
      INICIALES: {
        enabled: false,
        text: '',
        size: null,
        typography: null,
        color: null,
      },
    };

    return {
      options: [],
      selected: null,
      extra: {},
      sharedState: store.state,
      form: form[this.type],
    };
  },
  created() {
    if (
      this.type !== 'BORDADO' &&
      this.type !== 'INICIALES' &&
      this.type !== 'INICIALES'
    ) {
      this.setInitialValue();
    }

    if (this.type === 'BORDADO') {
      let promises = [];
      promises.push(actions.getEmbroideryCategoriesUnpaginated());

      promises.push(actions.getStandardEmbroideriesUnpaginated());

      promises.push(actions.getEmbroiderySettingsUnpaginated());

      Promise.all(promises).then((x) => {
        this.$set(
          this.extra,
          'standardEmbroideryCategories',
          x[0].data.results.map((y) => {
            return {
              value: y.id,
              text: y.reference,
            };
          })
        );

        this.$set(
          this.extra,
          'standardEmbroideries',
          x[1].data.results.map((y) => {
            return {
              value: y.id,
              text: y.reference,
              categories: y.categories,
              sizes: y.sizes,
              is_monocolor: y.is_monocolor,
              is_multicolor: y.is_multicolor,
              num_colors: y.num_colors,
              disabled: false,
            };
          })
        );

        this.$set(
          this.extra,
          'embroiderySizes',
          x[2].data.results[0].sizes.map((y) => {
            return {
              value: y.name,
              text: y.name,
            };
          })
        );

        const predefinedSizes = this.extra_info.embroideries_sizes.map(
          (y) => y.size
        );

        if (predefinedSizes.length > 0) {
          let tmp = [];
          for (
            let index = 0;
            index < this.extra.embroiderySizes.length;
            index++
          ) {
            const element = this.extra.embroiderySizes[index];
            if (predefinedSizes.includes(element.value)) {
              tmp.push({
                text: element.text,
                value: element.value,
                index: index,
              });
            }
          }

          this.$set(
            this.extra,
            'embroiderySizes',
            // this.extra.embroiderySizes.filter((yy) =>
            //   predefinedSizes.includes(yy.value)
            // )
            tmp
          );
        }

        this.setInitialValue();
      });
    }

    if (this.type === 'INICIALES') {
      let promises = [];
      promises.push(actions.getInitial(1));

      Promise.all(promises).then((x) => {
        this.$set(
          this.extra,
          'initialSizes',
          x[0].data.sizes.map((y) => {
            return {
              value: y.name,
              text: y.name,
            };
          })
        );

        this.$set(this.extra, 'allSizes', x[0].data.sizes);

        this.$set(
          this.extra,
          'initialTypographies',
          x[0].data.typographies.map((y) => {
            return {
              value: y.name,
              text: y.name,
              sizes: y.sizes,
              data: {
                real_typography: y.typography,
              },
            };
          })
        );

        const predefinedSizes = this.extra_info.initials_sizes.map(
          (y) => y.size
        );

        if (predefinedSizes.length > 0) {
          this.$set(
            this.extra,
            'initialSizes',
            this.extra.initialSizes.filter((yy) =>
              predefinedSizes.includes(yy.value)
            )
          );
        }
        this.setInitialValue();
      });
    }
  },

  methods: {
    disableIsMonocolor() {
      return !!(
        this.extra.standardEmbroideryCanBeMulticolor ^
        this.extra.standardEmbroideryCanBeMonocolor
      );
      // return this.$v.form.is_monocolor ^ this.$v.form.is_multicolor;
    },
    formatIsMonocolorStr() {
      if (this.$v.form.is_monocolor.$model) {
        return 'Monocolor';
      } else {
        if (this.$v.form.is_standard.$model) {
          return `Multicolor (${this.extra.standardEmbroideryNumColors} hilos)`;
        } else {
          return 'Multicolor (máx. 8 hilos)';
        }
      }
    },
    BORDADOSColorSwitchChanged(val) {
      if (val && this.form.colors.length > 1) {
        this.form.colors.splice(1, this.form.colors.length - 1);
      }
    },
    INICIALESChanged() {
      let summary = '';

      const colorNameIndex = this.extra_info.color_options.findIndex(
        (x) => x.value === this.form.color
      );

      const colorName =
        colorNameIndex >= 0
          ? this.extra_info.color_options[colorNameIndex].text
          : null;

      if (this.form.enabled) {
        if (
          ['Roma', 'Praga', 'Berlín', 'Londres', 'Viena', 'Oslo'].includes(
            this.form.typography
          )
        ) {
          this.form.text = this.form.text.toUpperCase();
        } else {
          this.form.text = this.form.text;
        }

        summary += 'Tipografía: ' + this.form.typography;
        summary += ' / Tamaño: ' + this.form.size;
        summary += ' / Color de hilo: ' + colorName;
        summary += ' / Iniciales: ' + this.form.text;
      } else {
        summary = 'Sin iniciales';
      }

      // let sizeIndex = this.extra.initialSizes.findIndex(
      //   (x) => x.value === this.$v.form.size.$model
      // );

      let sizeIndex2 = this.extra.allSizes.findIndex(
        (x) => x.name === this.$v.form.size.$model
      );

      this.$emit('optionSelected', {
        value: {
          enabled: this.form.enabled,
          text: this.form.text,
          size: this.form.size,
          typography: this.form.typography,
          color: this.form.color,
          renderer: {
            typography_visual: this.form.typography
              ? this.extra.initialFilteredTypographies.find((yyy) => {
                  return yyy.value === this.form.typography;
                }).data.real_typography
              : null,
            size_cm: this.form.typography
              ? this.extra.initialTypographies.find(
                  (zz) => zz.value === this.form.typography
                ).sizes[sizeIndex2].height
              : null,
          },
        },
        name: summary,
      });
    },

    INICIALESSizeChanged() {
      let sizeIndex = this.extra.initialSizes.findIndex(
        (x) => x.value === this.$v.form.size.$model
      );

      let filteredTypographies = [
        {
          text: '-- Selecciona --',
          value: null,
          disabled: false,
        },
      ];

      for (
        let index = 0;
        index < this.extra.initialTypographies.length;
        index++
      ) {
        const element = this.extra.initialTypographies[index];
        const disabled = !element.sizes[sizeIndex].enabled;
        filteredTypographies.push({
          text: element.text,
          value: element.value,
          disabled: disabled,
          data: {
            real_typography: element.data.real_typography,
          },
        });
      }

      this.$set(
        this.extra,
        'initialFilteredTypographies',
        filteredTypographies
      );
    },
    BORDADOChanged() {
      let summary = '';

      if (this.form.enabled) {
        const categorySelected = this.form.is_standard
          ? this.extra.standardEmbroideryCategories.find(
              (x) => x.value === this.form.category
            )
          : null;

        const embroiderySelected = this.form.is_standard
          ? this.extra.standardEmbroideries.find(
              (x) => x.value === this.form.embroidery
            )
          : null;

        summary += this.form.is_standard ? 'Estándar' : 'Personalizado';
        summary += ' / ' + this.form.size;

        summary += this.form.is_standard
          ? ' / ' +
            (categorySelected ? categorySelected.text : null) +
            ' / ' +
            (embroiderySelected ? embroiderySelected.text : null)
          : '';

        summary +=
          ' / ' + (this.form.is_monocolor ? 'Monocolor' : 'Multicolor');
        summary += ' / ' + this.form.colors.map((x) => x.text).join(',');
      } else {
        summary = 'Sin bordado';
      }

      this.$emit('optionSelected', {
        value: {
          enabled: this.form.enabled,
          is_standard: this.form.is_standard,
          size: this.form.size,
          category: this.form.category,
          embroidery: this.form.embroidery,
          image: this.form.image,
          is_monocolor: this.form.is_monocolor,
          colors: this.form.colors,
        },
        name: summary,
      });
    },
    setInitialValue() {
      if (
        this.type !== 'BORDADO' &&
        this.type !== 'INICIALES' &&
        this.type !== 'INPUT' &&
        this.type !== 'TAMANO' &&
        this.type !== 'TAMANO_DIAM' &&
        this.type !== 'TAMANO_LIBRE' &&
        this.type !== 'TAMANO_LIBRE_CAMA' &&
        this.type !== 'CAIDA'
      ) {
        let initialValue = this.selector_options[0].value;

        if (this.initialValue) {
          const indexIV = this.selector_options.findIndex(
            (x) => x.value === this.initialValue.value
          );
          if (indexIV >= 0) {
            initialValue = this.selector_options[indexIV].value;
            this.$v.form.value.$model = initialValue;
            this.genericOptionSelected(initialValue);
          } else {
            throw 'is this possible?';
          }
        } else {
          this.$v.form.value.$model = initialValue;
          this.genericOptionSelected(initialValue);
        }
      }

      if (this.type === 'CAIDA') {
        let initialValue = this.selector_options[0].value;

        if (this.initialValue) {
          // editing

          const indexIV = this.selector_options.findIndex(
            (x) => x.text === this.initialValue.name
          );
          if (indexIV >= 0) {
            initialValue = this.selector_options[indexIV].value;
            this.$v.form.fixed_size.$model = initialValue;
            this.CAIDAfixedSizeSelected(initialValue);
          } else {
            this.form.extra_fall = this.initialValue.value.fall;
            this.CAIDAOptionSelected();
          }
        } else {
          this.$v.form.fixed_size.$model = initialValue;
          this.CAIDAfixedSizeSelected(initialValue);
        }
      }

      if (this.type === 'TAMANO_LIBRE') {
        if (this.initialValue) {
          this.form.extra_width = this.initialValue.value.width;
          this.form.extra_length = this.initialValue.value.length;
          this.TAMANOOptionSelected();
        } else {
          this.form.extra_width = '100';
          this.form.extra_length = '70';
          this.TAMANO_LIBREOptionSelected();
        }
      }

      if (this.type === 'TAMANO_LIBRE_CAMA') {
        if (this.initialValue) {
          this.form.extra_width = this.initialValue.value.width;
          this.form.extra_length = this.initialValue.value.length;
          this.form.extra_height = this.initialValue.value.height;

          this.TAMANO_LIBRE_CAMAOptionSelected();
        } else {
          this.form.extra_width = '100';
          this.form.extra_length = '70';
          this.form.extra_height = '50';

          this.TAMANO_LIBRE_CAMAOptionSelected();
        }
      }

      if (this.type === 'TAMANO') {
        let initialValue = this.selector_options[0].value;

        if (this.initialValue) {
          // editing

          const indexIV = this.selector_options.findIndex(
            (x) => x.text === this.initialValue.name
          );
          if (indexIV >= 0) {
            initialValue = this.selector_options[indexIV].value;
            this.$v.form.fixed_size.$model = initialValue;
            this.TAMANOfixedSizeSelected(initialValue);
          } else {
            this.form.extra_width = this.initialValue.value.width;
            this.form.extra_length = this.initialValue.value.length;
            this.TAMANOOptionSelected();
          }
        } else {
          this.$v.form.fixed_size.$model = initialValue;
          this.TAMANOfixedSizeSelected(initialValue);
        }
      }

      if (this.type === 'TAMANO_DIAM') {
        let initialValue = this.selector_options[0].value;

        if (this.initialValue) {
          // editing

          const indexIV = this.selector_options.findIndex(
            (x) => x.text === this.initialValue.name
          );
          if (indexIV >= 0) {
            initialValue = this.selector_options[indexIV].value;
            this.$v.form.fixed_size.$model = initialValue;
            this.TAMANO_DIAMfixedSizeSelected(initialValue);
          } else {
            this.form.extra_diameter = this.initialValue.value.diameter;
            this.TAMANO_DIAMOptionSelected();
          }
        } else {
          this.$v.form.fixed_size.$model = initialValue;
          this.TAMANO_DIAMfixedSizeSelected(initialValue);
        }
      }

      if (this.type === 'INICIALES') {
        if (this.initialValue !== null) {
          if (this.initialValue.value.enabled) {
            this.$v.form.enabled.$model = this.initialValue.value.enabled;
            this.$v.form.text.$model = this.initialValue.value.text;
            this.$v.form.size.$model = this.initialValue.value.size;
            this.$v.form.typography.$model = this.initialValue.value.typography;
            this.$v.form.color.$model = this.initialValue.value.color;
            this.INICIALESSizeChanged();
          }
        }
        this.INICIALESChanged();
      }

      if (this.type === 'BORDADO') {
        // this.BORDADOColorsChanged();
        //this.$v.form.enabled.$model = false;
        if (this.initialValue !== null) {
          // this.initialValue.value.image = null;

          this.form = this.initialValue.value;

          const is_standard = this.$v.form.is_standard.$model;
          if (is_standard) {
            // standard
            const currentEmbroideryIndex = this.extra.standardEmbroideries.findIndex(
              (x) => x.value === this.$v.form.embroidery.$model
            );
            if (currentEmbroideryIndex >= 0) {
              this.$set(
                this.extra,
                'standardEmbroideryNumColors',
                this.extra.standardEmbroideries[currentEmbroideryIndex]
                  .num_colors
              );

              this.$set(
                this.extra,
                'standardEmbroideryCanBeMulticolor',
                this.extra.standardEmbroideries[currentEmbroideryIndex]
                  .is_multicolor
              );

              this.$set(
                this.extra,
                'standardEmbroideryCanBeMonocolor',
                this.extra.standardEmbroideries[currentEmbroideryIndex]
                  .is_monocolor
              );
            }
          }

          if (this.form.enabled && this.form.is_standard) {
            this.BORDADOFilterEmbroideriesByCategoryAndSize();
          }
        }
        this.BORDADOChanged();
      }

      if (this.type === 'INPUT') {
        // this.BORDADOColorsChanged();
        if (this.initialValue !== null) {
          this.form.value = this.initialValue.value;
        }
        this.INPUTChanged();
      }
    },
    BORDADOColorsChanged(selectedColors) {
      if (
        (this.form.is_monocolor && selectedColors.length === 1) ||
        (this.form.is_standard &&
          selectedColors.length <= this.extra.standardEmbroideryNumColors) ||
        (!this.form.is_standard && selectedColors.length > 0)
      ) {
        this.BORDADOChanged();
      }
    },
    BORDADOTypeChanged() {
      const is_standard = this.$v.form.is_standard.$model;
      if (is_standard) {
        // standard
        this.form.image = null;
        const currentEmbroideryIndex = this.extra.standardEmbroideries.findIndex(
          (x) => x.value === this.$v.form.embroidery.$model
        );
        if (currentEmbroideryIndex >= 0) {
          this.$set(
            this.extra,
            'standardEmbroideryNumColors',
            this.extra.standardEmbroideries[currentEmbroideryIndex].num_colors
          );
        }
      } else {
        // customized
        this.form.category = null;
        this.form.embroidery = null;
        this.form.colors = [];
        this.$set(this.extra, 'standardEmbroideryNumColors', 8);
      }
    },
    BORDADOgetDataURIFromFile(file) {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.onload = () => resolve(fileReader.result);
        fileReader.readAsDataURL(file);
      });
    },
    BORDADOImageChanged(newFile) {
      this.BORDADOgetDataURIFromFile(newFile).then((result) => {
        this.$v.form.image.$model = result;

        // this.$set(this.extra, 'customizedEmbroideryURI', result);
      });
    },
    BORDADOStandardEmbroideryChanged() {
      if (!this.$v.form.embroidery.$model) {
        return false;
      }

      const currentEmbroidery = this.extra.standardEmbroideries.find(
        (x) => x.value === this.$v.form.embroidery.$model
      );

      this.$set(
        this.extra,
        'standardEmbroideryCanBeMulticolor',
        currentEmbroidery.is_multicolor
      );
      this.$set(
        this.extra,
        'standardEmbroideryCanBeMonocolor',
        currentEmbroidery.is_monocolor
      );
      this.$set(
        this.extra,
        'standardEmbroideryNumColors',
        currentEmbroidery.num_colors
      );

      // Limit colors to new max number of colors

      if (this.form.colors.length > this.extra.standardEmbroideryNumColors) {
        this.form.colors = this.form.colors.slice(
          0,
          this.extra.standardEmbroideryNumColors
        );
      }

      if (
        !!(
          this.extra.standardEmbroideryCanBeMulticolor ^
          this.extra.standardEmbroideryCanBeMonocolor
        )
      ) {
        this.$v.form.is_monocolor.$model = this.extra.standardEmbroideryCanBeMonocolor;
      } else {
        this.$v.form.is_monocolor.$model = false;
      }
    },
    BORDADOFilterEmbroideriesByCategoryAndSize() {
      // index over product-enabled sizes
      let sizeIndex = this.extra.embroiderySizes.findIndex(
        (x) => x.value === this.$v.form.size.$model
      );

      let filteredEmbroideries = [
        {
          text: '-- Selecciona --',
          value: null,
          disabled: false,
        },
      ];
      for (
        let index = 0;
        index < this.extra.standardEmbroideries.length;
        index++
      ) {
        const element = this.extra.standardEmbroideries[index];
        if (element.categories.includes(this.$v.form.category.$model)) {
          // TODO: improve this, if possible.

          // element.sizes (sizes of embroideries) are index-based over all the possible list of
          // sizes (embroiderysettings), so sizeIndex is not applicable.
          // Thus, we first exclude all the element.sizes that are not enabled for the product, so that we can apply sizeIndex.
          const indexes = this.extra.embroiderySizes.map((yy, i2) => yy.index);
          const filterIndexes = element.sizes.filter((zz, i3) =>
            indexes.includes(i3)
          );

          const disabled = !filterIndexes[sizeIndex].enabled;
          filteredEmbroideries.push({
            text: element.text,
            value: element.value,
            disabled: disabled,
          });
        }
      }

      // If already selected is disabled, deselect (not done automatically)

      if (
        filteredEmbroideries.findIndex(
          (x) => x.value === this.$v.form.embroidery.$model && x.disabled
        ) >= 0
      ) {
        this.$v.form.embroidery.$model = null;
      }

      this.$set(
        this.extra,
        'standardEmbroideriesFiltered',
        filteredEmbroideries
      );
    },
    BORDADOStandardSizeChanged() {
      this.BORDADOFilterEmbroideriesByCategoryAndSize();
    },
    BORDADOStandardCategoryChanged() {
      this.BORDADOFilterEmbroideriesByCategoryAndSize();
    },
    INPUTChanged() {
      this.$emit('inputChanged', { value: this.form.value });
    },
    setDecimal(name, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.$v.form[name].$model = val;
      this.$v.form[name].$touch();
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    TAMANOOptionSelected() {
      this.$emit('optionSelected', {
        value: {
          width: this.form.extra_width,
          length: this.form.extra_length,
        },
      });
    },
    TAMANOfixedSizeSelected() {
      let dim = this.$v.form.fixed_size.$model.split('x');
      this.form.extra_width = dim[0].replace('cm', '');
      this.form.extra_length = dim[1].replace('cm', '');
      this.TAMANOOptionSelected();
    },
    CAIDAOptionSelected() {
      this.$emit('optionSelected', {
        value: {
          fall: this.form.extra_fall,
        },
      });
    },
    CAIDAfixedSizeSelected() {
      let dim = this.$v.form.fixed_size.$model;
      this.form.extra_fall = dim.replace('cm', '');

      this.CAIDAOptionSelected();
    },
    TAMANO_DIAMOptionSelected() {
      this.$emit('optionSelected', {
        value: {
          diameter: this.form.extra_diameter,
        },
      });
    },
    TAMANO_DIAMfixedSizeSelected() {
      let dim = this.$v.form.fixed_size.$model;
      this.form.extra_diameter = dim.replace('cm', '');
      this.TAMANO_DIAMOptionSelected();
    },
    TAMANO_LIBREOptionSelected() {
      this.$emit('optionSelected', {
        value: {
          width: this.form.extra_width,
          length: this.form.extra_length,
        },
      });
    },
    TAMANO_LIBRE_CAMAOptionSelected() {
      this.$emit('optionSelected', {
        value: {
          width: this.form.extra_width,
          length: this.form.extra_length,
          height: this.form.extra_height,
        },
      });
    },
    genericOptionSelected(value) {
      const name = this.selector_options.find((x) => x.value === value).text;
      this.$emit('optionSelected', { value: value, name: name });

      if (this.type === 'TELA') {
        const fabricsInfo = this.extra_info.fabricsInfo;

        if (fabricsInfo) {
          const fabricIndex = fabricsInfo.findIndex(
            (x) => x.id === this.$v.form.value.$model
          );

          if (fabricIndex >= 0) {
            const element = fabricsInfo[fabricIndex];

            this.form.barcadaInfo = {
              remaining_meters: parseFloat(
                element.meters_barcada_remaining
              ).toFixed(2),
              barcada: element.num_barcada,
            };
          } else {
            this.form.barcadaInfo = null;
          }
        }
      }
    },
  },
  mounted() {},
  updated() {
    //this.renderViews();
  },
};
</script>

<style lang="scss" scoped>
.canvas {
  width: 100%;
  height: 40em;
  /*background: #ebebeb;*/
}
/deep/ .multiselect.is-invalid {
  .multiselect__tags {
    border: 1px solid #dc3545;
  }
}
</style>
